export const ru = {
  client_privacy: {
    title: "Политика конфиденциальности",
    effective_date: "Дата вступления в силу: 10.03.2025",
    last_update: "Дата последнего обновления: 10.03.2025",
    introduction: "Настоящая Политика конфиденциальности регулирует сбор, использование и защиту персональных данных пользователей мобильного приложения \"Nasiyah Client\".",
    data_collection: {
      title: "1. Какие данные мы собираем?",
      items: [
        "Номер телефона (для входа в Приложение).",
        "Данные, введенные продавцом (имя, дата рождения, адрес, ID).",
        "Технические данные (IP-адрес, информация об устройстве, статистика Yandex Metrica)."
      ]
    },
    data_usage: {
      title: "2. Для чего мы собираем данные?",
      items: [
        "Идентификация пользователя.",
        "Просмотр и управление онлайн-договорами.",
        "Отслеживание графика платежей и отправка уведомлений.",
        "Аналитика и улучшение работы приложения."
      ]
    },
    data_protection: {
      title: "3. Как мы защищаем ваши данные?",
      items: [
        "Все данные хранятся в зашифрованном виде.",
        "Пользователи имеют доступ только к своим данным.",
        "Наши серверы защищены современными методами безопасности."
      ]
    },
    data_sharing: {
      title: "4. Передача данных третьим лицам",
      text: "Мы не передаем персональные данные третьим лицам, кроме аналитики (Yandex Metrica) или по требованию закона."
    },
    payment_data: {
      title: "5. Платежные данные",
      text: "Приложение не хранит и не обрабатывает платежные данные. Все платежи совершаются напрямую с продавцом."
    },
    user_rights: {
      title: "6. Ваши права",
      text: "Вы можете просматривать, изменять или удалять свои данные через приложение."
    },
    analytics: {
      title: "7. Использование аналитики",
      text: "Приложение использует Yandex Metrica для анализа работы (анонимизированные данные)."
    },
    age_restriction: {
      title: "8. Кто может использовать приложение?",
      text: "Только пользователи старше 18 лет."
    },
    policy_changes: {
      title: "9. Изменения в Политике",
      text: "Мы можем обновлять Политику. Новая версия будет опубликована в приложении."
    },
    contact: {
      title: "10. Контактные данные",
      email: "Email: support@nasiyah.uz",
      phone: "Телефон: +998933852600",
      address: "Адрес: г. Ташкент, Алмазарский район, ул. Сагбон, 23A"
    }
  },
  client_terms: {
    title: "Условия использования",
    effective_date: "Дата вступления в силу: 10.03.2025",
    last_update: "Последнее обновление: 10.03.2025",
    introduction: "Настоящие Условия использования регулируют использование мобильного приложения \"Nasiyah Client\" для управления договорами о рассрочке платежей.",
    description: {
      title: "1. Описание Приложения",
      intro: "\"Nasiyah Client\" позволяет клиентам:",
      items: [
        "Просматривать, принимать или отклонять онлайн-договоры.",
        "Отслеживать график платежей и получать напоминания.",
        "Управлять платежами по договору."
      ]
    },
    how_works: {
      title: "2. Как работает Приложение?",
      text: "Клиенты заходят в Приложение по номеру телефона и OTP-коду, проверяют договор от продавца и подписывают его."
    },
    features: {
      title: "3. Функции для клиентов",
      items: [
        "Разделение платежа на части.",
        "Отложение платежа на следующий месяц.",
        "Досрочное завершение договора.",
        "Получение уведомлений о сроках платежей."
      ]
    },
    obligations: {
      title: "4. Ваши обязанности",
      text: "Клиенты обязаны выполнять платежи продавцу в указанные сроки и поддерживать активность номера телефона."
    },
    liability: {
      title: "5. Ограничение ответственности",
      text: "Приложение не несет ответственности за споры между сторонами, так как оно только фиксирует и напоминает о платежах."
    },
    no_financial: {
      title: "6. Отсутствие финансовых операций",
      text: "Приложение не обрабатывает платежи, все расчеты происходят вне его."
    },
    termination: {
      title: "7. Прекращение использования",
      text: "Вы можете удалить учетную запись в любое время. В случае нарушения Условий доступ может быть заблокирован."
    },
    law: {
      title: "8. Применимое право",
      text: "Условия регулируются законодательством Республики Узбекистан."
    },
    contact: {
      title: "9. Контакты",
      email: "Email: support@nasiyah.uz",
      phone: "Телефон: +998933852600",
      address: "Адрес: г. Ташкент, Алмазарский район, ул. Сагбон, 23A"
    }
  },
  offer: {
    title: "Публичная оферта",
    status_label: "Активна",
    doc_badge: "Официальный документ · Публичная оферта",
    subtitle: "Публичная оферта на использование программы NASIYAH",
    lead: "Настоящая оферта составлена в соответствии со статьёй 832 Гражданского кодекса Республики Узбекистан и действует для любого дееспособного физического лица, акцептовавшего программу \"NASIYAH\".",
    meta: {
      date_label: "Дата и место",
      date: "25.02.2026 · г. Ташкент",
      executor_label: "Исполнитель",
      executor: "ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\"",
      reg: "Регистрационный номер: 3629602 · Центр государственных услуг Шайхантахурского района"
    },
    preamble: [
      "Настоящий договор является официальным предложением индивидуального предпринимателя \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\", владеющего программным средством \"NASIYAH\" (далее – программа) и зарегистрированного Центром государственных услуг Шайхантахурского района за регистрационным номером 3629602 (далее – Исполнитель), дееспособным физическим лицам (далее – Заказчик) о заключении договора оказания посреднических услуг в соответствии со статьёй 832 Гражданского кодекса Республики Узбекистан (далее – Договор) между сторонами, заключающими в программе соглашение на основе договора купли-продажи.",
      "Выполнение Заказчиком действий, указанных в настоящей оферте, означает безоговорочное принятие им изложенных ниже условий (акцепт оферты). С момента акцепта оферты договор считается заключённым.",
      "Во всех случаях, прямо не предусмотренных настоящим договором, стороны руководствуются законодательством Республики Узбекистан и обычаями делового оборота."
    ],
    sections: [
      {
        title: "01. Термины и определения",
        body: [
          "1.1. В настоящем договоре применяются следующие термины и определения:",
          "Банковская карта – платёжная карта, работающая в режиме онлайн, выпущенная банком Республики Узбекистан и зарегистрированная в платёжном сервисе поставщика.",
          "Персональные данные – информация, относящаяся к определённому физическому лицу или позволяющая его идентифицировать, предоставленная пользователем для использования сервиса.",
          "Договор купли-продажи – по договору купли-продажи одна сторона (продавец) обязуется передать товар в собственность другой стороне (покупателю), а покупатель обязуется принять этот товар и уплатить за него установленную денежную сумму (цену).",
          "Заказчик – дееспособное физическое лицо, заключающее договор оказания услуг (далее – Договор) в соответствии со статьёй 832 Гражданского кодекса Республики Узбекистан.",
          "Исполнитель – ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\", зарегистрированный Центром государственных услуг Шайхантахурского района за регистрационным номером 3629602."
        ]
      },
      {
        title: "02. Порядок акцепта",
        body: [
          "2.1. Акцепт настоящей оферты совершается Заказчиком после ознакомления с договором путём проставления в специальной программе отметки об ознакомлении.",
          "2.2. Заключая настоящий Договор, Заказчик даёт Исполнителю бессрочное согласие на использование своих персональных данных (фамилия, имя, отчество, ПИНФЛ, серия и номер паспорта, год и место рождения, адрес проживания и номер телефона) в соответствии с требованиями действующего законодательства о персональных данных, в том числе на их сбор, систематизацию, хранение, уточнение (обновление, изменение), копирование, использование, блокирование, удаление и уничтожение, с использованием средств автоматизации или без них, в целях исполнения настоящего договора. Также настоящим Заказчик даёт согласие на передачу персональных данных, предоставленных Исполнителю по настоящему договору, третьим лицам в целях исполнения настоящего договора.",
          "2.3. Исполнитель гарантирует Заказчику принятие всех необходимых мер по обеспечению конфиденциальности персональных данных Заказчика в соответствии с требованиями действующего законодательства Республики Узбекистан и Закона \"О персональных данных\". Согласие Заказчика на обработку его персональных данных (в том числе третьими лицами) считается бессрочным.",
          "2.4. Перед использованием услуги Заказчик обязан полностью ознакомиться с текстом настоящей оферты. Если вы полностью или частично не согласны с условиями оферты, вам следует отказаться от использования услуги."
        ]
      },
      {
        title: "03. Предмет договора",
        body: [
          "3.1. \"Исполнитель\" по поручению \"Заказчика\" регистрирует его персональные данные в специальной программе, а \"Заказчик\", пройдя регистрацию в специальной программе, обязуется разместить товар, который он намерен продать или приобрести, его свойства, характеристики, год выпуска, состояние и всю необходимую информацию о нём, изображения, а также заключить договор купли-продажи со второй стороной по соглашению.",
          "3.2. Согласно настоящему договору услуги, оказываемые \"Исполнителем\" посредством программы \"NASIYAH\": соединение продавца и покупателя средствами информационных технологий; создание возможности обмена информацией об условиях рассрочки; автоматизация процесса заключения договора; отражение графика платежей; оказание технических и информационных услуг, обеспечение информационной безопасности. ИСПОЛНИТЕЛЬ не участвует в продаже, поставке товара (работ, услуг) или приёме платежей."
        ]
      },
      {
        title: "04. Цена договора и порядок расчётов",
        body: [
          "4.1. Цена оферты определяется на основе платежей по установленной стоимости использования услуг \"PRO\" в программе \"NASIYAH\".",
          "4.2. Платежи по оферте осуществляются на 100 процентов авансом, и совершённый платёж действует только в течение 1 календарного месяца. Срок действия платежа исчисляется со дня оплаты до того же числа следующего месяца.",
          "4.3. Платёж осуществляется путём перечисления на расчётный счёт ИСПОЛНИТЕЛЯ, являющегося правообладателем программы \"NASIYAH\"."
        ]
      },
      {
        title: "05. Права и обязанности сторон",
        body: [
          "5.1. Права и обязанности \"Исполнителя\":",
          "5.1.1. Споры продавца и покупателя: ИСПОЛНИТЕЛЬ не несёт ответственности по сделкам, заключаемым между Продавцом и Покупателем, в части: качества товара; поставки; своевременности платежей; задержек; штрафов; задолженности; расторжения договора; претензий и споров. Такие споры разрешаются исключительно между Продавцом и Покупателем самостоятельно.",
          "5.1.2. По платежам и задержкам: ИСПОЛНИТЕЛЬ: не гарантирует своевременность платежей; не занимается взысканием задолженности; не участвует в начислении пеней, штрафов и процентов; не является представителем какой-либо из сторон по платёжным обязательствам. В случае задержки платежей Покупателем ИСПОЛНИТЕЛЬ не несёт никакой финансовой или юридической ответственности.",
          "5.1.3. ИСПОЛНИТЕЛЬ не является стороной, посредником, поручителем, агентом или представителем в сделке между продавцом и покупателем.",
          "5.1.4. Исполнитель несёт ответственность только в части работы программы, устранения технических сбоев и информационной безопасности. ИСПОЛНИТЕЛЬ не отвечает за финансовые потери Заказчиков.",
          "5.2. Права и обязанности \"Заказчика\":",
          "5.2.1. По договору купли-продажи Продавец обязан: предоставить полную и достоверную информацию о товаре, его характеристиках и всех других необходимых сведениях; поставить товар Покупателю и передать его; самостоятельно нести ответственность при возникновении спора.",
          "5.2.2. По договору купли-продажи Покупатель обязан: осуществлять платежи по установленному графику; соблюдать условия договора; нести ответственность за задержки платежей."
        ]
      },
      {
        title: "06. Ответственность сторон",
        body: [
          "6.1. Ответственность сторон определяется Гражданским кодексом Республики Узбекистан и Законом \"О договорно-правовой базе деятельности хозяйствующих субъектов\".",
          "6.2. Меры ответственности сторон, не предусмотренные настоящим договором, применяются в соответствии с действующим законодательством Республики Узбекистан."
        ]
      },
      {
        title: "07. Порядок разрешения споров",
        body: [
          "7.1. Споры и разногласия, которые могут возникнуть при исполнении настоящего договора и вследствие его неисполнения, разрешаются путём переговоров между Сторонами.",
          "7.2. В случае невозможности разрешения споров путём переговоров Стороны, после осуществления предусмотренного действующим законодательством порядка досудебного урегулирования разногласий, обращаются для их рассмотрения и разрешения по подведомственности и подсудности в межрайонный экономический суд города Ташкента."
        ]
      },
      {
        title: "08. Дополнительные условия и заключительные положения",
        body: [
          "8.1. При неисполнении или ненадлежащем исполнении \"Исполнителем\" обязательств по договору он по требованию \"Заказчика\" расторгается досрочно в одностороннем порядке.",
          "8.2. Досрочное расторжение договора \"Исполнителем\" осуществляется путём письменного обращения. При этом обязательства по договору должны быть исполнены надлежащим образом, а если обязательства не исполнены, должны быть указаны причины невозможности их исполнения. Причины досрочного расторжения договора рассматриваются с участием Сторон и оформляются в установленном порядке.",
          "8.3. После истечения срока действия настоящего договора исполнение обязательств между сторонами прекращается автоматически. При этом письменное согласие сторон не требуется.",
          "8.4. Настоящий договор об оказании услуг является договором гражданско-правового характера, и порядок его исполнения не подпадает под нормы Трудового кодекса и законодательства, а также не применяется к таким отношениям."
        ]
      }
    ],
    requisites: {
      title: "Реквизиты Исполнителя",
      rows: [
        { label: "Организация", value: "ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\"" },
        { label: "Регистрационный номер", value: "3629602" },
        { label: "Регистрирующий орган", value: "Центр государственных услуг Шайхантахурского района" },
        { label: "Платформа", value: "NASIYAH — информационно-технический посредник" }
      ]
    },
    acceptance: "✓ Электронный акцепт — подтверждается проставлением отметки в программе. С момента совершения акцепта договор считается заключённым · ст. 832 ГК РУз."
  },
  privacy: {
    title: "Политика конфиденциальности",
    status_label: "Активна",
    doc_badge: "Официальный документ · Политика конфиденциальности",
    subtitle: "Политика обработки персональных данных в программе NASIYAH (Nasiyah Business)",
    lead: "Настоящая Политика конфиденциальности разработана в соответствии с Законом Республики Узбекистан \"О персональных данных\" и определяет, как в программе NASIYAH собираются, обрабатываются и защищаются персональные данные пользователей.",
    meta: {
      date_label: "Дата вступления в силу",
      date: "10.03.2025 · г. Ташкент",
      executor_label: "Оператор",
      executor: "ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\"",
      reg: "Регистрационный номер: 3629602 · Центр государственных услуг Шайхантахурского района"
    },
    preamble: [
      "Настоящая политика регулирует порядок обработки персональных данных, получаемых индивидуальным предпринимателем \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\" (далее – Оператор) посредством программы \"Nasiyah Business\".",
      "Используя программу, Пользователь выражает согласие на обработку своих персональных данных на условиях, изложенных в настоящей политике. Если вы полностью или частично не согласны с условиями политики, вам следует отказаться от использования программы.",
      "В вопросах, не урегулированных настоящей политикой, применяется действующее законодательство Республики Узбекистан."
    ],
    sections: [
      {
        title: "01. Термины и определения",
        body: [
          "1.1. В настоящей политике применяются следующие термины и определения:",
          "Персональные данные – информация, относящаяся к определённому физическому лицу или позволяющая его идентифицировать, зафиксированная в электронной и (или) бумажной форме.",
          "Оператор – ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\", организующий и (или) осуществляющий обработку персональных данных.",
          "Пользователь – физическое лицо, использующее программу \"Nasiyah Business\" и предоставляющее свои персональные данные.",
          "Обработка – действия по сбору, систематизации, хранению, изменению, использованию, передаче, обезличиванию, блокированию и уничтожению персональных данных.",
          "Программа – принадлежащее Оператору программное обеспечение \"Nasiyah Business\" (NASIYAH)."
        ]
      },
      {
        title: "02. Общие положения",
        body: [
          "2.1. Целью настоящей политики является обеспечение законной обработки персональных данных Пользователей, а также открытое изложение подхода Оператора к их конфиденциальности и защите.",
          "2.2. Оператор обрабатывает персональные данные только в законных, чётко определённых целях и в объёме, необходимом для этих целей."
        ]
      },
      {
        title: "03. Собираемые персональные данные",
        body: [
          "3.1. Оператор может собирать через программу следующие персональные данные:",
          "Фамилия, имя и отчество;",
          "Номер телефона;",
          "Дата рождения;",
          "Адрес проживания;",
          "Данные удостоверения личности (ID)."
        ]
      },
      {
        title: "04. Цели обработки данных",
        body: [
          "4.1. Персональные данные обрабатываются в следующих целях:",
          "Создание и управление учётной записью Пользователя;",
          "Подготовка и управление онлайн-соглашениями;",
          "Идентификация Пользователей по номеру телефона или ID;",
          "Анализ работы программы и повышение качества услуг."
        ]
      },
      {
        title: "05. Меры по защите данных",
        body: [
          "5.1. Оператор принимает необходимые организационные и технические меры для защиты персональных данных от несанкционированного доступа, изменения, раскрытия или уничтожения, в том числе:",
          "Все данные хранятся в зашифрованном виде;",
          "Пользователи имеют доступ только к своим данным;",
          "Серверы защищены современными мерами информационной безопасности."
        ]
      },
      {
        title: "06. Передача данных третьим лицам",
        body: [
          "6.1. Оператор не передаёт персональные данные третьим лицам. Исключение составляют обмен в необходимом объёме с поставщиками услуг в аналитических целях, а также случаи, предусмотренные законодательством Республики Узбекистан."
        ]
      },
      {
        title: "07. Платёжная информация",
        body: [
          "7.1. Программа не хранит и не обрабатывает платёжные данные (данные банковских карт). Все платежи осуществляются сторонними платёжными системами в соответствии с их стандартами безопасности."
        ]
      },
      {
        title: "08. Права Пользователя",
        body: [
          "8.1. Пользователь имеет право просматривать свои персональные данные, уточнять (исправлять) или удалять их, а также отзывать ранее данное согласие на обработку.",
          "8.2. Реализация этих прав осуществляется через функционал программы или по контактным данным Оператора."
        ]
      },
      {
        title: "09. Использование аналитики",
        body: [
          "9.1. Оператор использует аналитический сервис Yandex Metrica для анализа использования программы и улучшения функциональности. При этом данные могут обрабатываться в обобщённом виде, не позволяющем идентифицировать личность."
        ]
      },
      {
        title: "10. Возрастное ограничение",
        body: [
          "10.1. Программа предназначена только для совершеннолетних (старше 18 лет) лиц. Оператор не обрабатывает заведомо персональные данные несовершеннолетних."
        ]
      },
      {
        title: "11. Изменения в политике",
        body: [
          "11.1. Оператор вправе вносить изменения в настоящую политику. Обновлённая версия вступает в силу с момента её публикации в программе."
        ]
      }
    ],
    requisites: {
      title: "Реквизиты Оператора",
      rows: [
        { label: "Организация", value: "ИП \"SHOMANSUROV SHOAZIM SHOAZIZ O'G'LI\"" },
        { label: "Регистрационный номер", value: "3629602" },
        { label: "Регистрирующий орган", value: "Центр государственных услуг Шайхантахурского района" },
        { label: "Платформа", value: "NASIYAH (Nasiyah Business)" },
        { label: "Контакт", value: "support@nasiyah.uz · +998933852600" }
      ]
    },
    acceptance: "✓ Используя программу, Пользователь считается принявшим условия настоящей Политики конфиденциальности · Закон РУз \"О персональных данных\"."
  },
  pricing: {
    eyebrow: "Тарифы",
    title: "Честный тариф — без скрытых платежей",
    subtitle:
      "Начните бесплатно и переходите на PRO, когда бизнес вырастет. Никаких скрытых комиссий.",
    popular: "Самый популярный",
    per_month: "сум / мес",
    pro: {
      rate: "PRO-тариф",
      payment_text: "Знакомство для новых предпринимателей",
      intro_headline: "{{months}} мес. бесплатно",
      after_intro: "— затем по этому тарифу",
      btn_text: "Начать — {{months}} мес. бесплатно",
    },
    free: {
      rate: "Бесплатный",
      price: "0",
      payment_text: "Всегда бесплатно",
      btn_text: "Начать бесплатно",
    },
    features: {
      debt_book: "Доступ к долговой книге",
      contracts: "Создание договоров",
      payments: "Прием платежей",
      analytics: "Финансовая аналитика",
      dashboard: "Дашборд и аналитика",
    },
  },
  common: {
    store_small: "Загрузите в",
    slogan: "Клиент забудет — Nasiyah напомнит!",
  },
  menu: {
    title: "Меню",
    open: "Открыть меню",
    close: "Закрыть",
    lang_uz: "O‘zbekcha",
    lang_ru: "Русский",
  },
  dock: {
    ios: "Скачать в App Store",
    android: "Скачать в Google Play",
  },
  nav: {
    main: "Главная",
    features: "Возможности",
    how: "Как это работает",
    download: "Скачать",
    pricing: "Цены",
    faq: "Вопросы",
    cta: "Начать бесплатно",
  },
  hero: {
    eyebrow: "Для предпринимателей",
    title_pre: "Сделайте рассрочку ",
    title_accent: "простой и надёжной",
    title_post: " для ваших клиентов.",
    subtitle:
      "Долговая книга, договоры и платежи в одном приложении — без бумаг, без ошибок, в реальном времени.",
    trust_count: "1,200+",
    trust_label: "предпринимателей работают с Nasiyah",
    card1_title: "850 000 сум получено",
    card1_name: "от Doniyor Rashidov",
    card2_title: "Договор 2506SAR30-1042-TE закрыт",
    card2_name: "Последний платёж — сегодня",
    mock: {
      title: "Договоры",
      archive: "Архив",
      seg_agreements: "Договоры",
      seg_clients: "Клиенты",
      search: "Клиент, телефон или товар",
      chip_all: "Все",
      chip_overdue: "Просроченные",
      chip_active: "Активные",
      chip_pending: "Ожидают подписи",
      status_overdue: "Просрочен",
      status_pending: "Ожидает",
      status_active: "Активен",
      status_draft: "Черновик",
      status_closed: "Закрыт",
      days_late: "Просрочка: {{n}} дн.",
      next_payment: "Следующий платёж",
      awaiting_sign: "Ожидает подписи",
      resend: "Отправить повторно",
      months: "{{a}}/{{b}} мес.",
      stages: "Этап {{a}} из {{b}}",
      resume: "Продолжить",
      fully_paid: "Полностью оплачено",
      create: "Создать договор",
      tab_home: "Главная",
      tab_agreements: "Договоры",
      tab_inbox: "Входящие",
      tab_debts: "Долги",
      toast_paid: "Платёж подтверждён",
    },
    stack: {
      accept: "Подтвердить",
      reject: "Отклонить",
      remind: "Напомнить",
      stamp_accept: "ПРИНЯТО",
      stamp_remind: "ОТПРАВЛЕНО",
      payment_in: "Платёж получен",
      days_late: "Просрочка: {{n}} дн.",
      days_until: "Через {{n}} дн.",
      yesterday: "Вчера",
      toast_reminded: "Напоминание отправлено",
    },
  },
  featuresCards: {
    card1: {
      title: "Быстрое создание договоров",
      subtitle: "Создавайте и подписывайте цифровые договоры в пару кликов.",
    },
    card2: {
      title: "Гибкие платежи",
      subtitle: "Частичная оплата, отсрочка или полное погашение.",
    },
    card3: {
      title: "Мощное управление клиентами",
      subtitle: "Вся информация о клиентах и их платежах в одном месте.",
    },
    card4: {
      title: "Умные напоминания",
      subtitle: "Автоматические уведомления о предстоящих платежах.",
    },
    card5: {
      title: "Блокировка IMEI ",
      subtitle: "Авто-блокировка устройства при просрочке.",
      soon: "Cкоро",
    },
    card6: {
      title: "Кредитная история клиента",
      subtitle: "Проверяйте платежеспособность клиентов заранее.",
      soon: "Cкоро",
    },
  },
  main: {
    features: "Возможности",
    features_title: "Управляйте платежами без стресса",
    features_subtitle:
      "Настройте гибкие условия, отправляйте автоматические напоминания и управляйте клиентами без лишних усилий.",
  },
  how: {
    eyebrow: "Как это работает",
    title: "Рассрочка в четыре шага",
    subtitle:
      "От регистрации до первого платежа — всё в телефоне, без лишних бумаг.",
    step1_title: "Скачайте приложение",
    step1_text:
      "Установите Nasiyah Бизнес и зарегистрируйте магазин за минуту.",
    step2_title: "Создайте договор",
    step2_text:
      "Выберите товар, сумму и график платежей — цифровой договор готов.",
    step3_title: "Клиент подписывает",
    step3_text:
      "Клиент видит договор в своём телефоне и подписывает на месте — бумага не нужна.",
    step4_title: "Авто-напоминания и контроль",
    step4_text:
      "Система следит за сроками, сама напоминает клиенту, а вы видите всё в реальном времени.",
    app: {
      home: {
        greeting: "Добрый день,",
        collected: "Собрано в сентябре",
        trend: "+14% к прошлому месяцу",
        qa_new: "Новый договор",
        qa_incoming: "Входящие платежи",
        qa_client: "Добавить клиента",
        qa_stats: "Статистика",
        pending: "В ожидании",
        all: "Все",
        recent: "Последние платежи",
        confirmed: "Подтверждён",
      },
      create: {
        title: "Новый договор",
        step_of: "{{n}}/4 · {{name}}",
        step_client: "Клиент",
        step_type: "Тип",
        step_finance: "Финансы",
        step_docs: "Документы",
        price: "Общая стоимость",
        down: "Первоначальный взнос",
        optional: "необязательно",
        term: "Срок",
        months: "{{n}} мес.",
        first_date: "Дата первого платежа",
        monthly: "Ежемесячный платёж",
        count: "Количество платежей",
        count_value: "{{n}}",
        total: "Итого",
        next: "Продолжить",
        photos: "Фото товара",
        photos_hint: "От 1 до 4 фото",
        photo: "фото {{n}}",
        add: "Добавить",
        signature: "Подпись клиента",
        sign_cta: "Поставить подпись",
        sms_note: "Клиенту придёт SMS со ссылкой на подпись",
        create: "Создать",
        sign_hint: "Клиент читает договор и расписывается здесь",
        sign_here: "Распишитесь здесь",
        clear: "Стереть",
        send: "Отправить",
        signed: "Подпись получена",
        redo: "Заново",
        toast_signed: "Подпись сохранена",
      },
      detail: {
        title: "Договор",
        type_tech: "Техника",
        status_overdue: "Просрочен",
        remaining: "Остаток долга",
        paid: "Оплачено",
        late_text: "Платёж {{amount}} ожидался {{date}}",
        schedule: "График платежей",
        schedule_meta: "{{n}} мес. · {{amount}}",
        row: "{{n}}-й платёж · {{date}}",
        st_paid: "Оплачен",
        st_late: "Просрочен",
        st_due: "Ожидается",
        more: "+ ещё {{n}} платежа",
        info: "Данные",
        client: "Клиент",
        phone: "Телефон",
        start: "Начало",
        number: "Номер",
        pdf: "Договор в PDF",
        accept_pay: "Принять платёж",
      },
    },
  },
  stats: {
    eyebrow: "В цифрах",
    title: "Предприниматели доверяют Nasiyah",
    s1_value: "1,247",
    s1_label: "активных предпринимателей",
    s2_value: "38,400+",
    s2_label: "созданных договоров",
    s3_value: "4.2 млрд",
    s3_label: "сумма платежей, сум",
    s4_value: "2 мин",
    s4_label: "среднее время договора",
    unit_bn: "млрд",
    unit_min: "мин",
    live_hint: "Живые данные — напрямую с платформы",
  },
  bento: {
    list_title: "Платежи на сегодня",
    list_overdue: "Просрочено",
    list_due: "Сегодня",
    list_paid: "Оплачено",
    toast_label: "Авто-напоминание",
    toast_title: "Напоминание отправлено",
    toast_text: "Doniyor — срок оплаты сегодня",
    pay_label: "График платежей",
    pay_status: "Активен",
    sign_label: "Цифровой договор",
    sign_status: "Подписан",
    chip_all: "Все",
    chip_debtors: "Должники",
    chip_overdue: "Просроченные",
    owes: "долг",
    paid: "оплачено",
    cash_loan: "Денежный долг",
    step_client: "Клиент",
    step_type: "Тип",
    step_finance: "Финансы",
    step_docs: "Документы",
    monthly: "{{p}} в месяц · {{n}} мес.",
    seg_full: "Полностью",
    seg_partial: "Частично",
    seg_defer: "Отсрочка",
    pay_amount: "Сумма платежа",
    rest: "Остаток долга: {{v}}",
  },
  faq: {
    eyebrow: "Вопросы и ответы",
    title: "Часто задаваемые вопросы",
    subtitle: "Главное, что нужно знать о Nasiyah.",
    help_text: "Остались вопросы? Напишите в Telegram.",
    help_btn: "Написать",
    // NOTE: this array is the single source for both the FAQ UI and the
    // FAQPage JSON-LD (subtask 05). Keep the {q, a} shape stable.
    items: [
      {
        q: "Что такое рассрочка и как помогает Nasiyah?",
        a: "Рассрочка — это продажа товара с оплатой по частям. Nasiyah объединяет долговую книгу, цифровой договор и контроль платежей в одном приложении: вы в реальном времени видите, кто и сколько должен, сроки оплаты и поступившие деньги.",
      },
      {
        q: "Как начать пользоваться Nasiyah?",
        a: "Скачайте приложение Nasiyah Бизнес в App Store или Google Play (iOS и Android), зарегистрируйте магазин и оформите первый договор за пару минут. Дополнительное оборудование или сложная установка не нужны.",
      },
      {
        q: "Как мой клиент видит и подписывает договор?",
        a: "Вы создаёте черновик договора в приложении и отправляете клиенту. Клиент через отдельное приложение Nasiyah (iOS/Android) просматривает условия и подтверждает — после этого договор вступает в силу. Свой график платежей и остаток долга клиент тоже отслеживает в этом приложении.",
      },
      {
        q: "Когда и как я получу деньги?",
        a: "Клиент платит напрямую вам — Nasiyah не удерживает деньги. Приложение ведёт график платежей, автоматически напоминает клиенту и фиксирует каждую оплату, поэтому учёт всегда точный.",
      },
      {
        q: "Сколько стоит Nasiyah? Это бесплатно?",
        a: "Долговая книга и управление клиентами — всегда бесплатно. Полные договоры, приём платежей и финансовая аналитика — в тарифе PRO. Для новых предпринимателей первые {{months}} мес. PRO бесплатно — затем {{price}} сум в месяц.",
      },
      {
        q: "Что если клиент задержит оплату?",
        a: "Система отмечает просроченные платежи и автоматически отправляет напоминание и вам, и клиенту. Вы видите на одном экране, кто и сколько должен и у кого просрочка.",
      },
      {
        q: "Безопасны ли мои данные?",
        a: "Каждый предприниматель видит данные только своих клиентов — аккаунты изолированы друг от друга. Каждый договор подтверждается цифровой подписью, данные передаются по защищённому соединению (HTTPS), и мы не продаём данные третьим лицам.",
      },
    ],
  },
  cta: {
    eyebrow: "Начните сегодня",
    title: "Без скрытых условий. Только честные тарифы.",
    subtitle:
      "Скачайте приложение Nasiyah Бизнес и оформите первый договор уже сегодня. Есть вопросы — напишите в Telegram.",
    telegram_btn: "Написать в Telegram",
  },
  footer: {
    upload: "Скачайте приложение",
    footer_copyright: "Все права защищены.",
    product: "Продукт",
    contact: "Контакты",
    address: "Ташкент, Алмазарский район, ул. Сагбан, 23А",
    privacy: "Политика конфиденциальности",
    terms: "Публичная оферта",
  },
  not_found: {
    meta_title: "Страница не найдена — Nasiyah",
    title_pre: "Такой страницы ",
    title_accent: "нет",
    text: "Ссылка устарела или в адресе ошибка. Вернитесь на главную или напишите нам в Telegram.",
    home_btn: "На главную",
  },
};
